(function () {
    angular.module('components.accordionColumns')
        .component('accordionColumns', {
            bindings: {
                animation: '&?',
                allOpen: '<?'
            },
            controller: accordionColumnsController
        });

    accordionColumnsController.$inject = ['$element'];
    function accordionColumnsController($element) {
        var ctrl = this;
        ctrl.$onInit = function () {
            $element.addClass('grid-block');
            if (ctrl.allOpen === undefined)
                ctrl.allOpen = true;
            ctrl.columns = [];
        }

        ctrl.registerColumn = function (column) {
            if (ctrl.allOpen)
                column.$element.addClass('open');
            ctrl.columns.push(column);
        }

        ctrl.registerContent = function (content) {
            ctrl.content = content;
        }

        ctrl.activateColumn = function (column) {
            ctrl.content.updateContent(column.currentLink)
            if (ctrl.currentColumn)
                ctrl.currentColumn.$element.removeClass('open');
            else {
                for (var i = 0; i < ctrl.columns.length; i++) {
                    ctrl.columns[i].$element.removeClass('open');
                }
            }
            column.$element.addClass('open');
            ctrl.currentColumn = column;
        }

        ctrl.clear = function () {
            for (var i = 0; i < ctrl.columns.length; i++) {
                ctrl.columns[i].clear();
            }
        }
    }
})();